/**
 * Uniform status pill (OneInvoice "DELIVERED / REJECTED / DRAFT" look).
 *
 *   <StatusBadge value="active" />            → tone inferred from value
 *   <StatusBadge value="Pending" tone="warning" />
 *
 * Tones: success | danger | warning | info | neutral | muted
 */
import React from 'react';

const TONE_CLASSES = {
  success: 'bg-emerald-600 text-white',
  danger: 'bg-red-600 text-white',
  warning: 'bg-amber-500 text-white',
  info: 'bg-sky-600 text-white',
  neutral: 'bg-slate-600 text-white',
  muted: 'bg-slate-200 text-slate-600',
};

const TONE_BY_VALUE = {
  // generic
  active: 'success', enabled: 'success', published: 'success', completed: 'success', passed: 'success',
  delivered: 'success', verified: 'success', converted: 'success', enrolled: 'success', issued: 'success',
  inactive: 'muted', disabled: 'muted', draft: 'muted', unpublished: 'muted', not_started: 'muted', archived: 'muted',
  failed: 'danger', rejected: 'danger', lost: 'danger', deactivated: 'danger', error: 'danger', expired: 'danger',
  pending: 'warning', pending_dns: 'warning', pending_review: 'warning', in_progress: 'warning', verifying: 'warning',
  attempted: 'warning', demo_scheduled: 'warning',
  new: 'info', contacted: 'info', interested: 'info', submitted: 'info', graded: 'info', invited: 'info',
  // roles
  super_admin: 'danger', tenant_admin: 'info', instructor: 'neutral', learner: 'success',
};

export function toneFor(value) {
  if (value === true) return 'success';
  if (value === false) return 'muted';
  const key = String(value ?? '').toLowerCase().replace(/\s+/g, '_');
  return TONE_BY_VALUE[key] || 'neutral';
}

export default function StatusBadge({ value, label, tone, className = '', ...rest }) {
  const t = tone || toneFor(value);
  const text = label ?? (typeof value === 'boolean' ? (value ? 'Active' : 'Inactive') : String(value ?? ''));
  return (
    <span
      className={`inline-flex items-center h-6 px-2.5 rounded text-[11px] font-semibold uppercase tracking-wide whitespace-nowrap ${TONE_CLASSES[t] || TONE_CLASSES.neutral} ${className}`}
      data-tone={t}
      {...rest}
    >
      {text.replace(/_/g, ' ')}
    </span>
  );
}
